module.exports = __webpack_public_path__ + "static/media/icon_delete_time_select.252f90f5.svg";